'use client';

import { c as _c } from "react/compiler-runtime";
import { TrafficOriginType } from '@cc-shopping/contracts/credit-cards-page/constants';
import { useIsMounted } from '@cc-shopping/hooks/useIsMounted';
import { Box, Dialog, Divider, IconButton, Slide, Typography } from '@mui/material';
import type { TransitionProps } from '@mui/material/transitions';
import React from 'react';
import { MenuItems } from './MenuItems';
type SeeAllMobileMenuProps = {
  isMenuOpen: boolean;
  handleCloseMenu: () => void;
  activeNavId: string;
  featureViewedActivityId: string;
  trafficOriginType?: TrafficOriginType;
};
const Transition = React.forwardRef(function Transition(props, ref) {
  const $ = _c(3);
  let t0;
  if ($[0] !== props || $[1] !== ref) {
    t0 = <Slide direction="up" ref={ref} {...props} />;
    $[0] = props;
    $[1] = ref;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
});
export const SeeAllMobileMenu = t0 => {
  const $ = _c(27);
  const {
    isMenuOpen,
    handleCloseMenu,
    activeNavId,
    featureViewedActivityId,
    trafficOriginType: t1
  } = t0;
  const trafficOriginType = t1 === undefined ? TrafficOriginType.Organic : t1;
  const isMounted = useIsMounted();
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingX: 3,
      paddingY: 2
    };
    t3 = <Typography variant="textBold" color="neutral.darker" id="see-all-menu-title">CREDIT CARD CATEGORIES</Typography>;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      position: "absolute",
      right: 8,
      top: 8
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span aria-hidden="true" className="mask-icon mask-icon-close" style={{
      width: 20,
      height: 20
    }} />;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== handleCloseMenu) {
    t6 = <Box sx={t2}>{t3}<IconButton onClick={handleCloseMenu} sx={t4} aria-label="Close menu">{t5}</IconButton></Box>;
    $[4] = handleCloseMenu;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Divider sx={{
      marginY: "8px !important"
    }} />;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== featureViewedActivityId) {
    t8 = {
      featureViewedActivityId
    };
    $[7] = featureViewedActivityId;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== activeNavId || $[10] !== handleCloseMenu || $[11] !== isMenuOpen || $[12] !== t8 || $[13] !== trafficOriginType) {
    t9 = <MenuItems trafficOriginType={trafficOriginType} activeNavId={activeNavId} isMenuOpen={isMenuOpen} onItemClickAction={handleCloseMenu} analyticsProps={t8} />;
    $[9] = activeNavId;
    $[10] = handleCloseMenu;
    $[11] = isMenuOpen;
    $[12] = t8;
    $[13] = trafficOriginType;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t6 || $[16] !== t9) {
    t10 = <>{t6}{t7}{t9}</>;
    $[15] = t6;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  const commonContent = t10;
  if (!isMounted) {
    let t11;
    if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = {
        position: "fixed",
        zIndex: 1000,
        top: 0,
        left: 0,
        height: "calc(100dvh - 1rem)",
        width: "calc(100dvw - 1rem)",
        backgroundColor: "white",
        overflowY: "auto",
        padding: 2
      };
      $[18] = t11;
    } else {
      t11 = $[18];
    }
    let t12;
    if ($[19] !== commonContent) {
      t12 = <Box sx={t11} role="dialog" aria-modal="true" aria-labelledby="see-all-menu-title" tabIndex={-1}>{commonContent}</Box>;
      $[19] = commonContent;
      $[20] = t12;
    } else {
      t12 = $[20];
    }
    return t12;
  }
  let t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      transition: Transition
    };
    t12 = {
      paper: {
        sx: {
          padding: 2
        }
      }
    };
    $[21] = t11;
    $[22] = t12;
  } else {
    t11 = $[21];
    t12 = $[22];
  }
  let t13;
  if ($[23] !== commonContent || $[24] !== handleCloseMenu || $[25] !== isMenuOpen) {
    t13 = <Dialog open={isMenuOpen} onClose={handleCloseMenu} fullScreen={true} slots={t11} slotProps={t12}>{commonContent}</Dialog>;
    $[23] = commonContent;
    $[24] = handleCloseMenu;
    $[25] = isMenuOpen;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  return t13;
};